/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import clsx from 'clsx';
import { Row, Col, Image, Space } from "antd";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import DropDown from "../../../../../assets/images/icon_menus/Drop Down.svg";
import DropUp from "../../../../../assets/images/icon_menus/Drop Up.svg";
import { NavLink, useParams } from "react-router-dom";
import { TextField } from "@mui/material";
import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { useDispatch, useSelector } from "react-redux";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DateIcon from "../../../../Shared/components/Icons/Date";
import { ListTable } from "./ListTable";
import actions from "../../redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import managementActions from "../../../Management/redux/actions";
import gstActions from "../../../../Admin/Setup/redux/actions";
import { FilterSelect } from "../../../../Shared/components/CustomSelect";
import crudActions from "../../../../CRUD/redux/actions";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import moment from 'moment';
import setUpActions from "../../../../YounoteAdmin/Setup/redux/actions";
import { checkViewPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import dayjs from 'dayjs';
import { AESDecrypt } from "../../../../../helpers/Crypto";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { FilterProductGroup } from "./FilterProductGroup";
//import FilterReset from "../../../../../assets/images/icon_actions/FilterReset.svg";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";


const InvoiceHistory = (props) => {
    const { customerDetails, loader } = useSelector(state => state.salesManagementReducer);
    const { businessDetails } = useSelector(state => state.homeReducer);
    const [dateValue, setDateValue] = useState([null, null]);
    const dispatch = useDispatch();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [picker, setPicker] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const prevSearch = usePrevious(search);
    const [sortBy, setSortBy] = useState("id");
    const [dataSettle, setDataSettle] = useState("un-paid");
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const timeoutRef = useRef(null);
    //const searchInput = useRef(null);
    let { invoiceCustomerID, invoiceOrderID } = useParams();
    const decryptedId = AESDecrypt(invoiceCustomerID);
    const { overDue } = useParams();

    const [importVisible, setImportVisible] = useState(false);

    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const { getList, getData } = useSelector(state => state.crudReducer);

    const [customerId, setCustomerId] = useState('');

    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;
    const [filterOpen, setFilterOpen] = useState(false);

    const onSelected = (data) => {
    }

    const customerObject = () => {
        let a = customerDetails && customerDetails.filter(function (el) { return el.id === parseInt(customerId) });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }


    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFillter(customerId, dateValue, dataSettle, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    dispatchFillter(customerId, dateValue, dataSettle, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Customer Invoice History', history, 'Sales')) {
                loadTasks();
            }
        }
        return () => {
            dispatch({ type: managementActions.CLEAR_MANAGEMENT_DETAILS_START });
        }

    }, [roleManagement]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFillter = (customerId = '', dateValue = [null, null], dataSettle = '', sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (invoiceOrderID) {
            filter['and'].push({ salesOrderId: invoiceOrderID });
        }

        if (customerId !== '') {
            filter['and'].push({ customerId: customerId });
        }

        if (search !== '') {
            or['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            or['or'].push({ customerName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ invoiceAmount: { like: '%' + search.trim() + '%' } });
        }

        if (overDue !== undefined) {
            filter['and'].push({ dueDate: { lt: moment().format('YYYY-MM-DD') } });
        }

        if (dateValue[0] !== null && dateValue[1] !== null) {
            filter['and'].push({ invoiceDate: { between: [dayjs(dateValue[0]).format('YYYY-MM-DD'), dayjs(dateValue[1]).format('YYYY-MM-DD')] } });
        }

        if (dataSettle !== '') {
            if (dataSettle === 'paid') {
                let createfilter = {
                    ["or"]: [
                        { ["and"]: [{ billStatus: "CONFIRMED" }] },
                        { ["and"]: [{ billStatus: "REVERSED" }] },
                        { ["and"]: [{ isSettled: true }, { billStatus: "CREATED" }] },
                        { ["and"]: [{ billStatus: "CANCELLED" }] }]
                };
                filter['and'].push(createfilter);
            } else {
                filter['and'].push({ isSettled: false }, { billStatus: "CREATED" });
            }
        }
        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        timeoutRef.current = null;
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'salesInvoice',
            skip: skip,
            filter: {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        })
    }

    const mobileFilterOpen = () => {

        setFilterOpen(true);
    }

    const loadTasks = useCallback(() => {
        if (invoiceCustomerID !== undefined && decryptedId !== 0) {
            setCustomerId(decryptedId);
        }
        dispatch({ type: setUpActions.REJECT_DETAILS_START });
        dispatch({
            type: gstActions.PRODUCTGST_DETAILS_START, url: 'productgst', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: managementActions.CUSTOMER_DETAILS_START, url: 'customerProfile', filter: {
                order: 'id desc'
            }
        });
        dispatchFillter(decryptedId === 0 ? '' : decryptedId, dateValue, dataSettle, sortBy, sortOrder);
    });

    const handleChangeCustomer = (value) => {
        setCustomerId(value);
        dispatchFillter(value, dateValue, dataSettle, sortBy, sortOrder);
    }
    const handleMobileFilter = (data) => {

        setCustomerId(data?.customerId);
        dispatchFillter(data, dateValue, dataSettle, sortBy, sortOrder);

    }

    const handleDates = (value, reset = false) => {
        setDateValue(value);
        if ((value[0] !== null && value[1] !== null) || reset) {
            dispatchFillter(customerId, value, dataSettle, sortBy, sortOrder);
        }
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFillter(customerId, dateValue, dataSettle, sortBy, sortOrder);
    }

    const handlePicker = (picker) => {
        setPicker(picker);
        setStartDate(null);
        setEndDate(null);
        if (!picker) {
            handleDates([null, null], true);
        }
    }

    const handleSettle = (value) => {
        setDataSettle(value);
        dispatchFillter(customerId, dateValue, value, sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFillter(customerId, dateValue, dataSettle, sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (invoiceOrderID) {
            filter['and'].push({ salesOrderId: invoiceOrderID });
        }

        if (customerId !== '') {
            filter['and'].push({ customerId: customerId });
        }

        if (search !== '') {
            or['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            or['or'].push({ customerName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ invoiceAmount: { like: '%' + search.trim() + '%' } });
        }
        if (dateValue[0] !== null && dateValue[1] !== null) {
            filter['and'].push({ date: { between: [dayjs(dateValue[0]).format('YYYY-MM-DD'), dayjs(dateValue[1]).format('YYYY-MM-DD')] } });
        }

        if (dataSettle !== '') {
            if (dataSettle === 'paid') {
                let createfilter = { ["or"]: [{ ["and"]: [{ isSettled: true }, { billStatus: "CREATED" }] }, { ["and"]: [{ isSettled: true }, { billStatus: "REVERSED" }] }, { ["and"]: [{ isSettled: false }, { billStatus: "CANCELLED" }] }] };
                filter['and'].push(createfilter);
            } else {
                filter['and'].push({ isSettled: false }, { billStatus: "CREATED" });
            }
        }

        filter['and'].push(or);

        dispatch({
            type: actions.SALES_INVOICE_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'salesInvoice',
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }


    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props} cls={'newImg'}
                img={SalesIcon} title={'Sales'}
                links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Customer Invoice History', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Customer Invoice History'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Customer Invoice History', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Inv. No., Name and, Inv. Amount'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                onChange={(e) => setSearch(e.target.value)}
                                                variant={'standard'}
                                                fullWidth
                                                id={idNamingConversion('Search', 'customerInvoiceHistory', 'TextField')}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.removeUnderline, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={clsx(classes.vertiCalScrollOverFlow, classes.customFilterSalesDiscount)}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' &&
                                                (checkComponentPermission('Customer Sales Price', 'Action', 'Customer specification Filter') ||
                                                    checkComponentPermission('Customer Sales Price', 'Action', 'Product Filter') ||
                                                    checkComponentPermission('Customer Sales Price', 'Page', 'Date Filter')) && <>
                                                    <NavLink
                                                        to="#"
                                                        className={clsx(classes.customLink, classes.customFilter)}
                                                        onClick={() => mobileFilterOpen()}>

                                                        <Image
                                                            src={FilterIcon}
                                                            preview={false}
                                                            className={clsx(classes.antImage)} />
                                                        <span className={clsx(classes.addLink, classes.color, classes.bold, classes.fwMedium)}>Filter</span>
                                                    </NavLink>
                                                </>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Invoice History', 'Action', 'All Customer') &&
                                                <AutoCompleteComponent
                                                    customLabel={"All Customers "}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={customerDetails}
                                                    customClasses={classes.customWidth172P}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    parentValue={customerObject()}
                                                    id={idNamingConversion('All Customers', 'customerInvoiceHistory', 'DropDown')}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            handleChangeCustomer(data);
                                                        }
                                                    }}
                                                    onChange={(data) => handleChangeCustomer(data.id)}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Invoice History', 'Action', 'Date Filter') &&
                                                <div className={clsx(classes.dateFilterwidth, classes.width250)}>
                                                    <Row>
                                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                                                            <NavLink to={'#'}
                                                                id={idNamingConversion('Date Filter', 'customerInvoiceHistory', 'Link')}
                                                                onClick={() => handlePicker(!picker)}
                                                                className={clsx(classes.textAlignLeft, classes.dateFilter, classes.dropDownBorder, classes.dropDownWidth, classes.margint0, classes.dropDownPointer)}>
                                                                Date Filter <Image
                                                                    src={picker ? DropUp : DropDown}
                                                                    preview={false} />
                                                            </NavLink>
                                                        </Col>
                                                        {
                                                            picker && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <div className={clsx(classes.dateFilterdateAdjust)}>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            views={['year', 'month', 'day']}
                                                                            allowKeyboardControl={false}
                                                                            value={startDate}
                                                                            label="From Date"
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor,

                                                                                },
                                                                                //inputProps: { value: moment(startDate).format('DD/MM/YYYY'), readOnly: false }
                                                                            }}
                                                                            format="dd/MM/yyyy"
                                                                            onChange={(newValue) => {
                                                                                handleDates([moment(newValue).format("YYYY-MM-DD"), endDate]);
                                                                                setStartDate(newValue);
                                                                            }}
                                                                            slotProps={{
                                                                                textField: {
                                                                                    id: idNamingConversion('From Date', 'customerInvoiceHistory', 'TextField'),
                                                                                    autoComplete: 'one-time-code'
                                                                                },
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            views={['year', 'month', 'day']}
                                                                            allowKeyboardControl={false}
                                                                            value={endDate}
                                                                            minDate={new Date(startDate)}
                                                                            label="To Date"
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor,

                                                                                },
                                                                                //inputProps: { value: moment(endDate).format('DD/MM/YYYY'), readOnly: false }
                                                                            }}
                                                                            format="dd/MM/yyyy"
                                                                            onChange={(newValue) => {
                                                                                handleDates([startDate, moment(newValue).format("YYYY-MM-DD")]);
                                                                                setEndDate(newValue);
                                                                            }}
                                                                            slotProps={{
                                                                                textField: {
                                                                                    id: idNamingConversion('To Date', 'customerInvoiceHistory', 'TextField'),
                                                                                    autoComplete: 'one-time-code'
                                                                                },
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </div>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </div>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Invoice History', 'Action', 'Paid') &&
                                                <FilterSelect
                                                    parentClasses={clsx(classes.dateFilterwidth, classes.width125)}
                                                    customClasses={clsx(classes.dropDownBorder, classes.dropDownWidth, classes.margint0, classes.dropDownPointer)}
                                                    details={[{ slug: "", label: "All" }, { slug: "paid", label: "Paid" }, { slug: "un-paid", label: "Un-paid" }]}
                                                    onChange={(e) => handleSettle(e.target.value)}
                                                    defaultValue={dataSettle}
                                                    heads={['slug', 'label']}
                                                    id={idNamingConversion('All', 'customerInvoiceHistory', 'DropDown')}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Invoice History', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'customerInvoiceHistory', 'Link')}
                                                    onClick={() => { loadImportExportData('InvoiceHistory'); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Invoice History', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                search={search}
                                customerId={customerId}
                                onSelected={onSelected}
                                dateValue={dateValue}
                                dataSettle={dataSettle}
                                overDue={overDue}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadTasks={() => dispatchFillter(customerId, dateValue, dataSettle, sortBy, sortOrder)}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                businessDetails={businessDetails}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}

                            />
                        </>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'InvoiceHistory'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={customerDetails}
                loadTasks={() => { dispatchFillter(sortBy, sortOrder) }}
            />
            <PrimaryDrawer
                open={filterOpen}
                title={'Filter and Product Group'}
                width={"360px"}
                handleClose={() => setFilterOpen(false)}
                className={clsx(classes.closeBackGround, classes.width100MaintainPrice)}
                component={
                    <FilterProductGroup
                        customerDetails={customerDetails}
                        handleCloseMobile={() => setFilterOpen(false)}
                        customerId={customerId}
                        customerObject={() => customerObject()}
                        handleMobileFilter={(data) => handleMobileFilter(data)}
                    />
                }
            />
        </React.Fragment >
    )
}
export default InvoiceHistory